import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UpdateWomanLedModalUI from './UpdateWomanLedModalUI.js'

class UpdateWomanLedModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      womanLed: this.props.account.womanLed,
      womanLedError: null
    }
  }

  render() {
    let booleanList = [
        { key: 'true', value: 'Yes' },
        { key: 'false', value: 'No' },
      ]
    return (
      <UpdateWomanLedModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        womanLed={this.state.womanLed}
        onWomanLedChange={(event) => { this.setState({ womanLed: event.target.value }) }}
        womanLedError={this.state.womanLedError}
        setWomanLedError={(error) => { this.setState({ womanLedError: error }) }}
        womanLedOptions={booleanList}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    if (this.state.submitted) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/womanLed`,
      this.onSubmitCallback,
      {
        womanLed: this.state.womanLed
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = response.errorList.map(error => error.message)

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 20)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default UpdateWomanLedModalSF
